export function wait(seconds: number) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(true);
    }, seconds);
  });
}
